import { render, staticRenderFns } from "./UsageConfirmation.vue?vue&type=template&id=2cc3ec54&"
import script from "./UsageConfirmation?vue&type=script&lang=ts&"
export * from "./UsageConfirmation?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports